// extracted by mini-css-extract-plugin
module.exports = {"PaginationBarContainer":"Pagination_PaginationBarContainer__2Q1YJ","PaginationBarItem":"Pagination_PaginationBarItem__3FbRv","CurrentPage":"Pagination_CurrentPage__2OAs8"};